<template>
    <div
        v-if="label || labelTooltip || $slots.labelTooltip"
        class="mb-0 flex items-center gap-1"
        @click.stop
    >
        <label
            v-if="label"
            class="mb-0 font-medium text-content-secondary"
            :class="[size === 'sm' ? 'text-content-sm' : 'text-content-md', { required, 'text-content-disabled': disabled }]"
            :for="id"
        >
            <slot name="label">
                <span class="whitespace-nowrap">
                    {{ label }}
                </span>
            </slot>
        </label>
        <DsIconButton
            v-if="labelTooltip || $slots.labelTooltip"
            class="label-tooltip-icon-button"
            icon="fa-regular fa-circle-info"
            size="xs"
            :tooltipText="labelTooltip"
            trigger="click"
        >
            <template
                v-if="$slots.labelTooltip"
                #tooltipContent
            >
                <slot name="labelTooltip" />
            </template>
        </DsIconButton>
    </div>
</template>

<script setup lang="ts">
import DsIconButton from '@/components/design-system/button/DsIconButton.vue';
import type { DsInputLabelProps } from '@ds/form/input/text/text-input.types';

withDefaults(defineProps<DsInputLabelProps>(), {
    disabled: false,
    size: 'md',
});
</script>

<style scoped lang="scss">
.required {
    &::after {
        content: '*';
        @apply text-content-error;
    }
}

:deep(.label-tooltip-icon-button.ds-button) {
    @apply h-5 w-5 p-0;

    .ds-icon-frame {
        @apply flex size-3 items-center justify-center;
        font-size: theme('spacing.3');
    }
}
</style>
